import { ProductRequestDtoStatusEnum } from "../../api";
import { Chip } from "../../components/common/chip";

export function statusChip(status: string, pendingLabel = "Pending") {
  if (status === ProductRequestDtoStatusEnum.Approved)
    return <Chip variant="approved">Approved</Chip>;
  if (status === ProductRequestDtoStatusEnum.Rejected)
    return <Chip variant="rejected">Rejected</Chip>;
  return <Chip variant="inReview">{pendingLabel}</Chip>;
}

export function formatDate(iso: string, monthFormat: "short" | "numeric" = "numeric") {
  return new Date(iso).toLocaleDateString("en-GB", {
    day: "numeric",
    month: monthFormat,
    year: "numeric",
  });
}
